import Text from '../Text';

interface PageHeaderProps {
  title: string;
  description: string;
}

const ThemedPageHeader = ({ title, description }: PageHeaderProps) => {
  return (
    <div className="flex w-full flex-col space-y-0.5">
      <Text
        as="h3"
        type="title"
        theme="default"
        className="break-words text-lg leading-tight tracking-normal text-gray-900 sm:text-xl"
      >
        {title}
      </Text>
      <Text
        as="p"
        type="body"
        theme="default"
        className="mt-1 max-w-2xl text-sm tracking-wide text-gray-500 opacity-75 sm:text-sm"
      >
        {description}
      </Text>
    </div>
  );
};

export default ThemedPageHeader;
